import React, { useEffect, useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { useProgramUIContext } from '../ProgramUIContext';
import { ProgramEditDialogHeader } from './ProgramEditDialogHeader';
import { ProgramEditForm } from './ProgramEditForm';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../_redux/program/programAction';
import { toast } from 'react-toastify';
import { toastOption } from '../../../../../../_metronic/_helpers';

export const ProgramEditDialog = ({ id, show, onHide }) => {
    // // Program UI Context
    const programUIContext = useProgramUIContext();
    const programUIProps = useMemo(() => {
        return {
            initProgram: programUIContext.initProgram,
            queryParams: programUIContext.queryParams,
            setQueryParams: programUIContext.setQueryParams,
        };
    }, [programUIContext]);

    // Program Redux state
    const dispatch = useDispatch();
    const { actionsLoading, programForEdit, error } = useSelector(
        (state) => ({
            actionsLoading: state.programs.actionsLoading,
            programForEdit: state.programs.programForEdit,
            error: state.programs.error
        }),
        shallowEqual,
    );
    if (error) {
        toast.error(error, toastOption)
    }


    useEffect(() => {
        // server call for getting Program by id
        dispatch(actions.fetchProgram(id));
    }, [id, dispatch]);

    const saveProgram = (program) => {
        if (!id) {
            dispatch(actions.createProgram(program)).then((response) => {
                toast.success(response.message, toastOption);
                dispatch(actions.fetchPrograms(programUIProps.queryParams)).then(() => onHide());
            });

        } else {
            dispatch(actions.updateProgram(program)).then((response) => {
                toast.success(response.message, toastOption);
                dispatch(actions.fetchPrograms(programUIProps.queryParams)).then(() => onHide());
            });
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="modal-sizes-title-lg"
        >
            <ProgramEditDialogHeader id={id} />
            <ProgramEditForm
                saveProgram={saveProgram}
                actionsLoading={actionsLoading}
                program={programForEdit || programUIProps.initProgram}
                onHide={onHide}
            />
        </Modal>
    );
};
